// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3gw2a","title":"ClientReferral_title__1oZ3n","itemText":"ClientReferral_itemText__3y_S4"};